var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { t } from 'i18next';
import { animate, fade, flyBelow } from '@lit-labs/motion';
import { BaseComponent } from '../utils/BaseComponent';
import '@a11y/focus-trap';
let Modal = class Modal extends BaseComponent {
    /**
     * Bind functions with 'this' ref to this component context forever!
     */
    constructor() {
        super();
        this.cancelText = t('Cancel');
        this.destructive = false;
        this.show = false;
        this.hideButtons = false;
        this.loading = false;
        this.confirm = async (e) => {
            this.loading = true;
            this.dispatchEvent(new CustomEvent('confirm', {
                composed: true,
                bubbles: true,
            }));
            this.loading = false;
            this.show = false;
        };
        this.cancel = async () => {
            this.dispatchEvent(new CustomEvent('cancel', {
                composed: true,
                bubbles: true,
            }));
        };
        this._handleKeyDown = this._handleKeyDown.bind(this);
    }
    _handleKeyDown(e) {
        if (e.key === 'Escape') {
            this.cancel();
        }
    }
    createRenderRoot() {
        const root = super.createRenderRoot();
        root.addEventListener('click', (e) => {
            if (e.target.id === 'Overlay') {
                this.cancel();
                e.stopPropagation();
                e.preventDefault();
            }
        });
        return root;
    }
    willUpdate(changedProperties) {
        document.removeEventListener('keydown', this._handleKeyDown);
        if (changedProperties.has('show')) {
            if (this.show) {
                document.addEventListener('keydown', this._handleKeyDown);
            }
            else {
                document.removeEventListener('keydown', this._handleKeyDown);
            }
        }
    }
    disconnectedCallback() {
        document.removeEventListener('keydown', this._handleKeyDown);
    }
    render() {
        return this.show ? html `
      <div class='bg-black/50 fixed w-full h-full top-0 left-0 z-20 flex justify-center items-end md:items-center'
           id='Overlay'
           ${animate({ keyframeOptions: { duration: 200 }, in: fade, out: fade })}>
  ${this.show ? html `
    <div
        role='dialog'
        aria-modal=true
        id="Container"
        class='flex justify-center p-16 md:p-32 rounded-t-lg md:rounded-lg bg-white w-full md:w-fit'
        ${animate({ keyframeOptions: { duration: 300 }, in: flyBelow, out: flyBelow })}>
          <focus-trap class="w-full mb-32 md:mb-0">
            <slot></slot>
            ${!this.hideButtons ? html `
              <div class='flex justify-end gap-16 mt-16'>
                <trust-button dataTest="cancel" quiet @click=${this.cancel}>${this.cancelText}</trust-button>
                <trust-button dataTest="confirm" autoFocus ?destructive=${this.destructive} ?loading=${this.loading} @click=${this.confirm}>
                  ${this.confirmText}
                </trust-button>
              </div>
            ` : nothing}
          </focus-trap>
        </div>` : nothing}
      </div>
    ` : nothing;
    }
};
__decorate([
    property()
], Modal.prototype, "cancelText", void 0);
__decorate([
    property()
], Modal.prototype, "confirmText", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "destructive", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "show", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "hideButtons", void 0);
__decorate([
    state()
], Modal.prototype, "loading", void 0);
__decorate([
    query('#Container')
], Modal.prototype, "_container", void 0);
Modal = __decorate([
    customElement('trust-modal')
], Modal);
export { Modal };
//# sourceMappingURL=modal.js.map